import { Chip, chipToneOf, type ChipLead } from '@/components/ui/chip';
import type { Level } from '@/domain/constants';
import { Msg } from '@/lib/locale-context';
import { Phrase } from './phrase';
import styles from './values.module.css';
import { healthWords, type HealthState } from './words';

/** The dot's shape per grade: filled for critical, a ring for warning. The
 *  quiet grades wear the tone alone, as on every row (HEALTH_SIGNALS_V2 §8:
 *  a notice never takes the dot). */
const DOT: Record<Level, ChipLead | undefined> = {
  critical: { dot: 'filled' },
  warning: { dot: 'ring' },
  notice: undefined,
  info: undefined,
};

/**
 * A health state (docs/DESIGN_SYSTEM.md "Values and entries"): the kit
 * `Chip`, tinted by the grade's tone, with its dot; the tone and the dot's
 * shape carry the severity, and no grade word stands beside it. Its words
 * name the grade. Server-safe.
 */
export function HealthValue({ state, className }: { state: HealthState; className?: string }) {
  return (
    <span className={[styles.health, className].filter(Boolean).join(' ')} data-value="health">
      <Chip tone={chipToneOf(state.level)} lead={DOT[state.level]}>
        <Phrase
          message={healthWords(state)}
          shown={{
            state: (
              <span>
                <Msg message={state.label} />
              </span>
            ),
          }}
        />
      </Chip>
    </span>
  );
}
